import { render, staticRenderFns } from "./UpdateStaff.vue?vue&type=template&id=5f0d7bb2"
import script from "./UpdateStaff.vue?vue&type=script&lang=js"
export * from "./UpdateStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports